const getItemUuidsWithLang = ({ itemsToAdd, allItems, langUuid }) => {
	const uuidList = [];
	if (!itemsToAdd || !itemsToAdd.length) {
		return [];
	}
	itemsToAdd.forEach((product) => {
		const productMatch = allItems.find(productItem => product.id === productItem.id && productItem.languageUuid === langUuid);
		if (productMatch && !productMatch.length && productMatch.uuid) {
			uuidList.push(productMatch.uuid);
		}
	});
	return uuidList;
};

export default getItemUuidsWithLang;



// WEBPACK FOOTER //
// ./src/helpers/getItemUuidsWithLang.js